import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { stepLabels } from "./performanceUi";

const canSelectStep = (step) => !(step.blocked && step.code !== "OBJECTIFS_N_MOINS_1");

export default function PerformanceStepper({ steps, activeCode, onSelect }) {
    return (
        <nav className="pm-stepper" aria-label="Etapes performance">
            <div className="pm-stepper__track">
                {steps.map((step, index) => {
                    const isActive = step.code === activeCode;
                    const isCompleted = step.completed || step.status === "COMPLETED";
                    const isBlocked = step.blocked && step.code !== "OBJECTIFS_N_MOINS_1";
                    const canSelect = canSelectStep(step);

                    let stateClass = "pm-stepper__item--future";
                    if (isActive) stateClass = "pm-stepper__item--active";
                    else if (isCompleted) stateClass = "pm-stepper__item--done";
                    else if (isBlocked) stateClass = "pm-stepper__item--blocked";

                    return (
                        <React.Fragment key={step.code}>
                            {index > 0 && (
                                <div
                                    className={`pm-stepper__line${isCompleted ? " pm-stepper__line--done" : ""}`}
                                />
                            )}
                            <button
                                type="button"
                                className={`pm-stepper__item ${stateClass}`}
                                onClick={() => canSelect && onSelect(step.code)}
                                title={step.blockedReason || step.label || stepLabels[step.code]}
                                disabled={isBlocked}
                                aria-current={isActive ? "step" : undefined}
                            >
                                <span className="pm-stepper__dot">
                                    {isCompleted && !isActive ? (
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    ) : (
                                        <span className="pm-stepper__dot-num">{index + 1}</span>
                                    )}
                                </span>
                                <span className="pm-stepper__label">{step.label || stepLabels[step.code] || step.code}</span>
                            </button>
                        </React.Fragment>
                    );
                })}
            </div>
        </nav>
    );
}

export function PerformanceStepArrows({ steps, activeCode, onSelect }) {
    const activeIndex = steps.findIndex((step) => step.code === activeCode);
    const previousStep = activeIndex > 0 ? steps[activeIndex - 1] : null;
    const nextStep = activeIndex >= 0 && activeIndex < steps.length - 1 ? steps[activeIndex + 1] : null;
    const canGoPrevious = Boolean(previousStep && canSelectStep(previousStep));
    const canGoNext = Boolean(nextStep && canSelectStep(nextStep));

    return (
        <div className="perf-step-arrows" aria-label="Navigation des étapes">
            <button
                className="perf-step-arrow"
                type="button"
                disabled={!canGoPrevious}
                onClick={() => canGoPrevious && onSelect(previousStep.code)}
                title={previousStep?.label || stepLabels[previousStep?.code] || "Étape précédente"}
                aria-label="Étape précédente"
            >
                <ChevronLeft size={20} />
            </button>
            <button
                className="perf-step-arrow perf-step-arrow--primary"
                type="button"
                disabled={!canGoNext}
                onClick={() => canGoNext && onSelect(nextStep.code)}
                title={nextStep?.label || stepLabels[nextStep?.code] || "Étape suivante"}
                aria-label="Étape suivante"
            >
                <ChevronRight size={20} />
            </button>
        </div>
    );
}
